// extracted by mini-css-extract-plugin
export default {"policyModal":"styles_policyModal__YqCMM","title":"styles_title__GGVAy","list":"styles_list__4FYAk","button":"styles_button__40GMh"};